// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__ZvCmS","icon":"input_icon__qgGVQ"};